import { Button } from "@mui/material";
import { useEffect } from "react";
import { ASSETS_PATH } from './../../constants';
import * as THREE from 'three';
import "./../../styles/PopLockNorth.scss";

let isCanvas = false;
let gSpaceImage;



const LockNorth = ({onClose, northDirection, setNorthDirection, spaceImage}) => {


    useEffect(() => {

        lon = northDirection;
        gSpaceImage = spaceImage;

        if(!isCanvas){
            init();
            isCanvas = !isCanvas;
        }

        return () => {
            isCanvas = false;
            renderer.dispose();
            renderer.setAnimationLoop(null);
        }

    }, [])


    const onUpdateAndClose = () => {
        const northDirection = Math.round(lon);
        // If degrees goes in minus make it plus by adding 360 degree.
        // if degrees goes more than 360 then divide it by 360 and use remainder.
        setNorthDirection(northDirection > 0 ? northDirection > 360 ? northDirection % 360 : northDirection : northDirection + 360);
        onClose();
    }



    return(
        <>
        <div className="pop-background">

            </div>

            <div className="pop-north-container">
                <div className="pop-header">
                    Lock North Direction
                </div>
                <div className="pop-content" id="3d-view">
                </div>
                <div className="pop-footer">
                    <Button onClick={onUpdateAndClose}>Update and Close</Button>
                    <Button onClick={onClose}>close</Button>
                </div>
            </div>
        </>
    )
}

export default LockNorth;

//// Three JS

let camera, scene, renderer;

let isUserInteracting = false,
    onPointerDownMouseX = 0, onPointerDownMouseY = 0,
    lon = 0, onPointerDownLon = 0,
    lat = 0, onPointerDownLat = 0,
    phi = 0, theta = 0;
let container;
let mesh;


function init() {

    container = document.getElementById('3d-view');

    camera = new THREE.PerspectiveCamera(75, container.offsetWidth / container.offsetHeight, 1, 1100);

    scene = new THREE.Scene();

    const geometry = new THREE.SphereGeometry(500, 60, 40);
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale(- 1, 1, 1);
    //console.log(`${ASSETS_PATH}/${gHotspot.space_image}`);
    const texture = new THREE.TextureLoader().load(`${ASSETS_PATH}/${gSpaceImage}`);
    texture.colorSpace = THREE.SRGBColorSpace;
    const material = new THREE.MeshBasicMaterial({ map: texture });

    mesh = new THREE.Mesh(geometry, material);

    scene.add(mesh);


    renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    renderer.setAnimationLoop(animate);
    container.appendChild(renderer.domElement);

    container.style.touchAction = 'none';
    container.addEventListener('pointerdown', onPointerDown);

    // document.addEventListener('wheel', onDocumentMouseWheel);

    window.addEventListener('resize', onWindowResize);

}

function onWindowResize() {

    camera.aspect = container.offsetWidth / container.offsetHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(container.offsetWidth, container.offsetHeight);

}

function onPointerDown(event) {


    if (event.isPrimary === false) return;

    isUserInteracting = true;

    onPointerDownMouseX = event.clientX;
    onPointerDownMouseY = event.clientY;

    onPointerDownLon = lon;

    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);

}

function onPointerMove(event) {


    if (event.isPrimary === false) return;

    lon = (onPointerDownMouseX - event.clientX) * 0.1 + onPointerDownLon;


}




function onPointerUp(event) {

    if (event.isPrimary === false) return;

    isUserInteracting = false;

    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerup', onPointerUp);

}


function animate() {

    /* if ( isUserInteracting === false ) {

        lon += 0.1;

    } */

    console.log(lon);

    lat = Math.max(- 85, Math.min(85, lat));
    phi = THREE.MathUtils.degToRad(90 - lat);
    theta = THREE.MathUtils.degToRad(lon);

    const x = 500 * Math.sin(phi) * Math.cos(theta);
    const y = 500 * Math.cos(phi);
    const z = 500 * Math.sin(phi) * Math.sin(theta);

    camera.lookAt(x, y, z);

    renderer.render(scene, camera);

}